module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "structure-next"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_c('span', {
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_vm._v("Copyright ")]), _vm._v("© 2016 by Matt Tran")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Published by Mango Media Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Front Cover Image: Elina Diaz")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Back Cover Image: Laura Mejía")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Cover Design: Elina Diaz and Laura Mejía ")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Interior Design, Theme and Layout: Elina Diaz and Laura Mejía.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed or transmitted in any form or by any means without prior written permission.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("ISBN 978-1-63353-093-5")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f447ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/NGJobHacks_split_001.vue
// module id = 60
// module chunks = 0